// extracted by mini-css-extract-plugin
export var addButton = "_mn-0";
export var border = "_mn-8";
export var check = "_mn-h";
export var danger = "_mn-6";
export var dropdownContainer = "_mn-1";
export var editModalBody = "_mn-j";
export var footerContainer = "_mn-i";
export var fullWidth = "_mn-a";
export var hide = "_mn-9";
export var icon = "_mn-3";
export var input = "_mn-7";
export var inputFlex = "_mn-b";
export var inputWrapper = "_mn-c";
export var manualFocus = "_mn-5";
export var optionButton = "_mn-4";
export var pillWrapper = "_mn-e";
export var pointer = "_mn-2";
export var showOverflow = "_mn-f";
export var tagsFlex = "_mn-d";
export var xButton = "_mn-g";